import React, {useState} from 'react';
import {Box, IconButton, Button, Menu, MenuItem} from "@mui/material";
import {Delete, Edit, Add, LibraryAddOutlined, ArrowDropDown, ImportExport} from "@mui/icons-material";
import {Link, useNavigate} from "react-router-dom";
import {deleteItemType} from "../API/KB/KBAPI.js";
import {backgroundColor, colorBlack, colorSecondary, colorWhite, mobileButton, themeMode} from "../App/theme.js";
import { isMobile } from "../App/utils.js";
import ListIcon from '@mui/icons-material/FormatListBulleted';
import {useConfirm} from "../Components/ConfirmContext";

const HeaderButtons = ({ itemTypes, embeddingConfigured, fetchKB, setIsLoading, setImportOpen }) => {
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const [anchorEl4, setAnchorEl4] = useState(null);
    const navigate = useNavigate();

    const showConfirm = useConfirm();

    return (
            <Box mt={4} display="flex" flexWrap="wrap" justifyContent="flex-end">
                <>
                    <Button
                        style={{
                            ...mobileButton,
                            position: isMobile ? undefined : 'absolute',
                            top: isMobile ? undefined : 110,
                            zIndex: isMobile ? undefined : 10,
                        }}
                        variant="outlined"
                        color="primary"
                        endIcon={<ArrowDropDown />}
                        onClick={(e) => setAnchorEl4(e.currentTarget)}
                    >
                        Actions
                    </Button>
                    <Menu
                        style={{ marginTop: 4 }}
                        anchorEl={anchorEl4}
                        open={Boolean(anchorEl4)}
                        onClose={() => setAnchorEl4(null)}
                    >
                        {[
                            { name: 'Create new Type', path: '/new-item-type', icon: <LibraryAddOutlined /> },
                            { name: 'Import web pages', action: () => setImportOpen(true), icon: <ImportExport /> },
                        ]?.map((action) => (
                            <MenuItem key={action.name} onClick={() => {
                                setAnchorEl4(null);

                                if (action.path) {
                                    navigate(action.path);
                                } else {
                                    action.action();
                                }

                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', width: '220px' }}>
                                    {action.icon}
                                    <span style={{ marginLeft: '8px' }}>{action.name}</span>
                                </div>
                            </MenuItem>
                        ))}
                    </Menu>
                </>

                {!!itemTypes?.length && <>
                    {embeddingConfigured && (
                        <Button
                            style={{
                                ...mobileButton,
                                top: isMobile ? undefined : '16px',
                            }}
                            variant="outlined"
                            color="primary"
                            endIcon={<ArrowDropDown />}
                            onClick={(e) => setAnchorEl2(e.currentTarget)}
                        >
                            Item Types
                        </Button>
                    )}
                    <Menu
                        style={{ marginTop: 4 }}
                        anchorEl={anchorEl2}
                        open={Boolean(anchorEl2)}
                        onClose={() => setAnchorEl2(null)}
                    >
                        {itemTypes?.map((itemTypeKey) => (
                            <MenuItem key={itemTypeKey}>
                                <span onClick={() => {
                                    setAnchorEl2(null);
                                    navigate(`/edit-item-type/${itemTypeKey}`)
                                }} style={{ width: '148px' }} >{itemTypeKey}</span>

                                <IconButton onClick={async () => {
                                    setAnchorEl2(null);
                                    navigate(`/edit-item-type/${itemTypeKey}`)
                                }}>
                                    <Edit fontSize="small" />
                                </IconButton>

                                <IconButton onClick={async () => {
                                    const confirmed = await showConfirm({
                                        title: 'Delete Item Type Confirmation',
                                        content: `Are you sure you want to delete "${itemTypeKey}" type?`
                                    })

                                    if (confirmed) {
                                        setIsLoading(true);
                                        await deleteItemType(itemTypeKey);
                                        fetchKB();
                                        setIsLoading(false);
                                    }

                                }}>
                                    <Delete fontSize="small" />
                                </IconButton>
                            </MenuItem>
                        ))}
                    </Menu>
                </>}

                <>
                    {!!itemTypes?.length && <Button
                        variant={"contained"}
                        color="secondary"
                        style={{
                            ...mobileButton,
                            position: isMobile ? undefined : "absolute",
                            top: isMobile ? undefined : 205,
                            zIndex: isMobile ? undefined : 10
                        }}
                        onClick={(e) => {
                            if (itemTypes?.length) {
                                setAnchorEl3(e.currentTarget);
                            } else {
                                navigate(`/new-item`);
                            }

                        }}
                        startIcon={ <Add style={{ color: colorWhite }} /> }
                    >
                        New Item
                    </Button>}

                    {!!itemTypes?.length && <Menu
                        style={{ marginTop: 4 }}
                        anchorEl={anchorEl3}
                        open={Boolean(anchorEl3)}
                        onClose={() => setAnchorEl3(null)}
                    >
                        {itemTypes?.map((itemTypeKey) => (
                            <MenuItem key={itemTypeKey}>
                                <span onClick={() => {
                                    setAnchorEl3(null);
                                    navigate(`/new-item?type=${itemTypeKey}`);
                                }} style={{ width: '220px' }} >{itemTypeKey}</span>
                            </MenuItem>
                        ))}
                    </Menu>}
                </>
            </Box>
    );
}

export default HeaderButtons;